import { useState } from "react";
import LeftNavSubmenuItemGroup from "./LeftNavSubmenuItemGroup";
import LeftNavLink from "./LeftNavLink";

export default function LeftNavMenuItem(props) {
  const [open, setOpen] = useState(false);
  const { item: el, insideRouter, isActive, isSubitem} = props;

  const children =
    el.subitems && el.subitems.length
      ? el.subitems.map((el2, idx2) => (
          <LeftNavSubmenuItemGroup
            item={el2}
            key={idx2}
            insideRouter={insideRouter}
          />
        ))
      : null;

  let className = `${isActive ? "active" : ""} ${isSubitem ? "is-submenu": "" }`;
  const childless = (
    <li id={el.elementId} className={className}>
      <LeftNavLink item={el} insideRouter={insideRouter}>
        {el.label}
      </LeftNavLink>
    </li>
  );

  className = open ? "dropdown open" : "dropdown";
  if (isActive) {
    className += " active";
  }
  if (isSubitem) {
    className += " is-submenu";
  }
  const withChildren = (
    <li
      className={className}
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}

    >
      <a
        href="#"
        className="dropdown-toggle"
        data-toggle="dropdown"
        data-hover="dropdown"
        data-delay={10000}
        data-close-others="true"
      >
        <span className="title">{el.label}</span>
        <span className="selectedArrow" />
      </a>
      <ul className="dropdown-menu CustomDropdownCss">{children}</ul>
    </li>
  );
  return children ? withChildren : childless;
}
